import React, { Component } from "react"
import './index.scss'

import aircraftIcon from '@/images/newHome/aircraft.png'
import stepSuccessIcon from '@/images/newHome/step_success.png'

class IndexStep extends Component {

    state = {
        currentStep: 0,
        stepList: [
            {
            title: "领取试读体验课",
            },
            {
            title: "预约排课",
            },
            {
            title: "正式试读体验",
            },
        ],
        animate: false
    }

    componentDidMount(){
        const target = document.querySelector("#idexStepsContent");
        const callback = (entries, observer) => {
            if (entries[0].intersectionRatio <= 0.1) {
                this.setState({
                    animate: false
                })
                return
            }

            this.setState({
                animate: true
            })
        };
        const options = {};
        const observer = new IntersectionObserver(callback, options);
        observer.observe(target);
    }

    render(){
        return (
            <div className={`index-steps ${this.state.animate ? 'index-steps-animate' : ''}`}>
                <div className="aircraft-box">
                    <img className="aircraft-img" src={aircraftIcon} />
                </div>

                <div className="steps-box">
                    <div className="line">
                        <div className="progress"></div>
                    </div>

                    <div className="content" id="idexStepsContent">
                        {
                            this.state.stepList.map((item, index) => (
                                <div className={`steps steps-active-${index}`} key={index}>
                                    <div className="num">{ (index+1).toString().length > 1 ? (index+1) : ('0' + (index+1)) }</div>
                                    <div className="img">
                                        <img className="done-icon" src={stepSuccessIcon}/>
                                    </div>
                                    <p className="title">{ item.title }</p>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default IndexStep